var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg360View(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 17,
    viewBox: "0 0 26 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0.75C6.1 0.75 0.5 3.55 0.5 7C0.5 9.8 4.175 12.1625 9.25 12.9625V15.4875C9.25 16.05 9.925 16.325 10.3125 15.925L13.8 12.4375C14.05 12.1875 14.05 11.8 13.8 11.55L10.3125 8.0625C10.2244 7.97612 10.1127 7.91776 9.99143 7.89477C9.87019 7.87178 9.74486 7.88519 9.63124 7.93332C9.51762 7.98144 9.42078 8.06212 9.35293 8.16519C9.28509 8.26826 9.24927 8.38911 9.25 8.5125V10.4125C5.3125 9.7125 3 8.0375 3 7C3 5.675 6.8 3.25 13 3.25C19.2 3.25 23 5.675 23 7C23 7.825 21.5 9.1 18.85 9.925C18.3375 10.0875 18 10.5625 18 11.1C18 11.9375 18.8125 12.55 19.6 12.3C23.1375 11.2 25.5 9.2375 25.5 7C25.5 3.55 19.9 0.75 13 0.75Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg360View);
export default __webpack_public_path__ + "static/media/360View.baf2b6e3.svg";
export { ForwardRef as ReactComponent };